export const TOP_BANNER_HEIGHT = 28;
export const NAVBAR_HEIGHT = {
  normal: 100,
  scrolled: 80,
  checkout: 90
};
export const SCROLL_THRESHOLD = 20;
export const SEARCH_FIELD_WIDTH = '100%';
export const SEARCH_FIELD_HEIGHT = 32;
export const LOGO_SIZE = {
  normal: 50,
  scrolled: 40,
};
export const BADGE_SIZE = 18;














